export class EntTradeRegistryFilter {
  page: number;
  size: number;
  deleted: boolean;
  year?: number;
  month?: number;
  tradeType?: string;
  citizenshipId?: number;
  productTypeId?: number;
  regionOfDispatchId?: number;
  regionOfArrivalId?: number;

  constructor(init?: Partial<EntTradeRegistryFilter>) {
	this.page = 1;
	this.size = 30;
	this.deleted = false;
	if (init) {
	  Object.assign(this, init)
	}
  }
}
